<template>
  <div class="c-pt-5 c-pl-2 c-sm:c-pl-4 flex c-md:hidden c-flex-col megamenu__parent megamenu__parent--christmas">
    <router-link
      :to="dynamicProductPath('ready_easter')"
      class="megamenu__link relative c-p-2 c-sm:c-p-3 c-lg:c-p-4 flex c-flex-col c-flex-grow-1 shadow text-center"
    >
      <div class="megamenu__icon embed-responsive c-mb-0 c-lg:mb-n2 mt-n4">
        <MobileEasterSvg class="icon embed-responsive-item image-contain" />
      </div>
      <p class="font-medium mt-O c-mb-0 c-ml-auto c-mr-auto relative">
        {{ t('easter') }}
      </p>
    </router-link>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import MobileEasterSvg from "@/components/svg/navbarMenu/MobileEasterSvg.vue";
import { useCategoriesStore } from '@/stores/CategoriesStore'

const { t } = useI18n()
const { dynamicProductPath } = useCategoriesStore()
</script>

<i18n>
  {
    "cs": {
    "birthday": "Narozeniny",
    "christmas": "Valentýn",
    "easter": "Velikonoce"
},
    "sk": {
    "birthday": "Narodeniny",
    "christmas": "Valentín",
    "easter": "Veľká noc"
},
    "pl": {
    "birthday": "Urodziny",
    "christmas": "Walentynki",
    "easter": "Wielkanoc"
},
    "hu": {
    "birthday": "Szülinap",
    "christmas": "Valentin-nap",
    "easter": "Húsvét"
},
    "de": {
    "birthday": "Geburtstag",
    "christmas": "Valentinstag",
    "easter": "Ostern"
},
    "at": {
    "birthday": "Geburtstag",
    "christmas": "Valentinstag",
    "easter": "Ostern"
},
    "ro": {
    "birthday": "Aniversare",
    "christmas": "Valentine's Day",
    "easter": "Paște"
},
    "fr": {
    "birthday": "Anniversaire",
    "christmas": "Saint-Valentin",
    "easter": "Pâques"
},
    "it": {
    "birthday": "Compleanno",
    "christmas": "San Valentino",
    "easter": "Pasqua"
}
  }
</i18n>
